(ns practitest.frontend.kanban.main
  (:require [practitest.frontend.kanban.views :as views]
            [practitest.frontend.kanban.subs]
            [practitest.frontend.kanban.events]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]
            [re-frame.db]))

(defn kanban-view []
  [views/main-panel])

(def main-controller
  {:stop (fn [_]
           (re-frame/dispatch [:kanban/cleanup]))})

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:kanban/initialize (js->clj config :keywordize-keys true)]))
